<div *ngIf="!isInteractive" class="flex gap-2">
    <span class="typography-body-xs-regular">{{rating | number: '1.1-1' }}</span>
    <div class="flex gap-2">
        <ng-container *ngFor="let star of stars; let i = index">
            <img class="w-4 h-4" [src]="star === 'full' ? 'assets/icons/star.svg' : star === 'half' ? 'assets/icons/star-half.svg' : 'assets/icons/star-empty.svg'" alt="Star">
        </ng-container>
    </div>
</div>
<div *ngIf="isInteractive" class="flex flex-col gap-1">
    <div class="flex justify-center gap-2 px-4">
        <ng-container *ngFor="let i of getArrayUpTo(maxStars)">
            <img
                class="w-12 h-12 cursor-pointer"
                [src]="i + 1 <= (hoverRating || rating) ? 'assets/icons/star.svg' : 'assets/icons/star-empty.svg'"
                (mouseenter)="setHover(i + 1)"
                (mouseleave)="clearHover()"
                (click)="onSelectedRating(i + 1)"
                alt="Star" />
        </ng-container>
    </div>
    <div class="flex justify-between">
        <span class="typography-body-m-medium">1 - {{'cacademy.could_be_better' | translate}}</span>
        <span class="typography-body-m-medium">5 - {{'cacademy.very_good' | translate}}</span>
    </div>
</div>